var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dummyInput" }, [
    _c("div", { staticClass: "inputEquipment" }, [
      _c(
        "div",
        {
          staticClass: "clickContent",
          attrs: { "data-tag": "clear" },
          on: { click: _vm.hitEnter }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3)
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputTitle" }, [
      _c("span", [_vm._v("修改价格")]),
      _vm._v(" "),
      _c("span", [_vm._v("（原价："), _c("i", [_vm._v("￥20")]), _vm._v("）")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "priceInput" }, [
      _c("input", { attrs: { type: "text", placeholder: "输入结算价" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputContent" }, [
      _c("span", { attrs: { "data-number": "1", "data-tag": "clear" } }, [
        _c("i", { attrs: { "data-number": "1", "data-tag": "clear" } }, [
          _vm._v("1")
        ])
      ]),
      _vm._v(" "),
      _c("span", { attrs: { "data-number": "2", "data-tag": "clear" } }, [
        _c("i", { attrs: { "data-number": "2", "data-tag": "clear" } }, [
          _vm._v("2")
        ])
      ]),
      _vm._v(" "),
      _c("span", { attrs: { "data-number": "3", "data-tag": "clear" } }, [
        _c("i", { attrs: { "data-number": "3", "data-tag": "clear" } }, [
          _vm._v("3")
        ])
      ]),
      _vm._v(" "),
      _c(
        "span",
        { attrs: { "data-number": "rollback", "data-tag": "clear" } },
        [
          _c("i", {
            staticClass: "iconfont icon-zuojiantou",
            attrs: { "data-number": "rollback", "data-tag": "clear" }
          })
        ]
      ),
      _vm._v(" "),
      _c("span", { attrs: { "data-number": "4", "data-tag": "clear" } }, [
        _c("i", { attrs: { "data-number": "3", "data-tag": "clear" } }, [
          _vm._v("4")
        ])
      ]),
      _vm._v(" "),
      _c("span", { attrs: { "data-number": "5", "data-tag": "clear" } }, [
        _c("i", { attrs: { "data-number": "5", "data-tag": "clear" } }, [
          _vm._v("5")
        ])
      ]),
      _vm._v(" "),
      _c("span", { attrs: { "data-number": "6", "data-tag": "clear" } }, [
        _c("i", { attrs: { "data-number": "6", "data-tag": "clear" } }, [
          _vm._v("6")
        ])
      ]),
      _vm._v(" "),
      _c("span", { attrs: { "data-number": "clear", "data-tag": "clear" } }, [
        _c("i", {
          staticClass: "iconfont icon-chacha",
          attrs: { "data-number": "clear", "data-tag": "clear" }
        })
      ]),
      _vm._v(" "),
      _c("span", { attrs: { "data-number": "7", "data-tag": "clear" } }, [
        _c("i", { attrs: { "data-number": "7", "data-tag": "clear" } }, [
          _vm._v("7")
        ])
      ]),
      _vm._v(" "),
      _c("span", { attrs: { "data-number": "8", "data-tag": "clear" } }, [
        _c("i", { attrs: { "data-number": "8", "data-tag": "clear" } }, [
          _vm._v("8")
        ])
      ]),
      _vm._v(" "),
      _c("span", { attrs: { "data-number": "9", "data-tag": "clear" } }, [
        _c("i", { attrs: { "data-number": "9", "data-tag": "clear" } }, [
          _vm._v("9")
        ])
      ]),
      _vm._v(" "),
      _c("span", { attrs: { "data-number": "return", "data-tag": "clear" } }, [
        _c("i", {
          staticClass: "iconfont icon-duihao",
          attrs: { "data-number": "return", "data-tag": "clear" }
        })
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticStyle: { visibility: "hidden" },
          attrs: { "data-number": "none", "data-tag": "clear" }
        },
        [_c("i", { attrs: { "data-number": "none", "data-tag": "clear" } })]
      ),
      _vm._v(" "),
      _c("span", { attrs: { "data-number": "0", "data-tag": "clear" } }, [
        _c("i", { attrs: { "data-number": "0", "data-tag": "clear" } }, [
          _vm._v("0")
        ])
      ]),
      _vm._v(" "),
      _c("span", { attrs: { "data-number": "none", "data-tag": "clear" } }, [
        _c("i", { attrs: { "data-tag": "clear" } }, [_vm._v(".")])
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticStyle: { visibility: "hidden" },
          attrs: { "data-number": "none", "data-tag": "clear" }
        },
        [_c("i", { attrs: { "data-number": "none", "data-tag": "clear" } })]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "operatingButton" }, [
      _c("span", [_vm._v("取消")]),
      _vm._v(" "),
      _c("span", [_vm._v("确认")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-efe37e6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efe37e6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/paperless/components/dummyInput/index.vue
// module id = null
// module chunks = 